const equipmentStatusComponent = {
  template: require('./equipment-status.html'),
  restrict: 'E',
  controller: EquipmentStatusController,
  controllerAs: 'vm',
  bindings: {
    series: '<'
  }
};

function EquipmentStatusController() {
  'ngInject';

  var vm = this;
  vm.groupedGauges = {};
  vm.stateSeries = [];

  vm.$onDestroy = function () {};

  vm.$onChanges = function () {};
}

export default equipmentStatusComponent;